import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { TowerGroupDto } from 'src/app/api/models';
import { BookingStepsComponent } from 'src/app/modules/bookings/booking-steps/booking-steps.component';
import { BookingStatus } from 'src/shared/models/enums';
import { GeolocationService } from 'src/shared/services/helpers/geolocation.service';
import { HelperService } from 'src/shared/services/helpers/helper.service';
import { FacilitiesListComponent } from "../../../facilities/facilities-list/facilities-list.component";
import { IconComponent } from "../../../../../../shared/components/elements/icon/icon.component";
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'vl-facility-list-wrapper',
  templateUrl: './facility-list-wrapper.component.html',
  styleUrls: ['./facility-list-wrapper.component.scss'],
  imports: [FacilitiesListComponent, IconComponent, NgIf, TranslatePipe],
})
export class FacilityListWrapperComponent  implements OnInit {
  @Input() groups: TowerGroupDto[];
  @Input() currentStep: BookingStatus = BookingStatus.Subscription;
  constructor(
    private modalCtrl: ModalController,
    private helperService: HelperService,
    private geolocationService: GeolocationService,
  ) { }

  ngOnInit() {
    console.log(this.currentStep);
    
    this.geolocationService.calculateDistanceForList(this.groups, () => {
    }).subscribe();
    this.groups.map(g => {
      g['iconName'] = this.helperService.getStatusIconName(g);
    });
  }

  back() {
    this.modalCtrl.dismiss();
  }

  async openModal(g, step = this.currentStep) {
    await this.modalCtrl.dismiss();
    if(g) {
        let componentProps = {
          group: g,
          fromBuySubscription: true
        };
        if (step) {
            componentProps = {
                ...componentProps,
                ...{
                    currentStep: step
                }
            };
        }
        const modal = await this.modalCtrl.create({
            id: 'booking-details',
            component: BookingStepsComponent,
            cssClass: ['auto-height'],
            componentProps: componentProps
        });

      modal.onWillDismiss().then(() => {
      });
      return await modal.present();
    }
}

}
